import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import "./Contact.css";
import { sendContactMessage } from "../../Utils/storeService";

const Contact = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const farmId = searchParams.get("farm");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const form = new FormData(e.target);
    const payload = {
      name: (form.get("user_name") || "").trim(),
      email: (form.get("user_email") || "").trim(),
      message: (form.get("message") || "").trim(),
      // Sent as its own field rather than glued onto the message body, so the enquiry can be
      // filtered by farm later instead of only read by a human.
      farmId: farmId || null,
    };

    setSending(true);
    try {
      await sendContactMessage(payload);
      setSubmitted(true);
    } catch (err) {
      const status = err?.response?.status;
      setError(
        status === 400
          ? err?.response?.data?.message ||
              t("contact.invalid", {
                defaultValue: "Please check your details and try again.",
              })
          : status === 429
          ? t("contact.too_many", {
              defaultValue:
                "Too many messages sent. Please wait a moment and try again.",
            })
          : t("contact.send_failed", {
              defaultValue:
                "Unable to send your message right now. Please try again later.",
            })
      );
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <h2>{t("contact.title")}</h2>
        <p className="contact-tagline">{t("contact.tagline")}</p>
        <div className="contact-form-wrapper">
          {submitted ? (
            <div className="thank-you-message" role="status" aria-live="polite">
              <h3>{t("contact.thank_you_title")}</h3>
              <p>{t("contact.thank_you_message")}</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {farmId && (
                <p className="contact-farm-context">
                  {t("contact.regarding_farm", { id: farmId, defaultValue: `Regarding Farm #${farmId}` })}
                </p>
              )}
              <input
                type="text"
                name="user_name"
                maxLength={200}
                placeholder={t("contact.name_placeholder")}
                aria-label={t("contact.name_placeholder")}
                required
              />
              <input
                type="email"
                name="user_email"
                autoComplete="email"
                placeholder={t("contact.email_placeholder")}
                aria-label={t("contact.email_placeholder")}
                required
              />
              <textarea
                name="message"
                maxLength={5000}
                placeholder={t("contact.message_placeholder")}
                aria-label={t("contact.message_placeholder")}
                defaultValue={farmId ? t("contact.farm_message_prefix", { id: farmId, defaultValue: `I have a question about Farm #${farmId}: ` }) : ""}
                required
              />
              <button type="submit" disabled={sending}>
                {sending
                  ? t("contact.sending", { defaultValue: "Sending…" })
                  : t("contact.send_message")}
              </button>
              {error ? (
                <p className="contact-error" role="alert">
                  {error}
                </p>
              ) : null}
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default Contact;
